import React from 'react'
import { StyledButton, Text, GifImage } from './styles'
// import Gif from '@/assets/images/Check.gif'
import { useTranslation } from 'react-i18next'
import { Link, useParams, useHistory } from 'react-router-dom'
import { useSelector } from 'react-redux'

const SubmitButton = ({ showPopup, isheader = false }) => {
  const { t } = useTranslation()
  const { surveyId } = useParams()
  const history = useHistory()
  const {
    answered,
    unanswered,
    answerLoading,
    attachedQuestionAnswerCompulsory
  } = useSelector(state => state.answer)

  const confectioneryClick = e => {
    e.preventDefault()
    unanswered || attachedQuestionAnswerCompulsory
      ? showPopup(true)
      : history.push(`/survey/${surveyId}/review`)
  }

  return (
    <Link onClick={confectioneryClick} to='#'>
      <StyledButton type='primary' isheader={isheader} disabled={!answered.length || answerLoading}>
        <Text>
          {t(`components.bunge.button.submit`)}
        </Text>
        {/* {answered.length && process.env.REACT_APP_THEME === 'bunge' ? (
          <GifImage src={Gif} />
        ) : null} */}
      </StyledButton>
    </Link>
  )
}

const SubmitButtonMobile = ({ showPopup }) => {
  const { t } = useTranslation()
  const { surveyId } = useParams()
  const history = useHistory()
  const {
    answered,
    unanswered,
    answerLoading,
    attachedQuestionAnswerCompulsory
  } = useSelector(state => state.answer)

  const confectioneryClick = e => {
    e.preventDefault()
    unanswered || attachedQuestionAnswerCompulsory
      ? showPopup(true)
      : history.push(`/survey/${surveyId}/review`)
  }

  return (
    <Link onClick={confectioneryClick} to='#'>
      <StyledButton
        type='primary'
        mobile={'true'}
        isheader={false}
        disabled={!answered.length || answerLoading}
      >
        <Text>
          {t(`components.bunge.button.submit`)}
        </Text>
      </StyledButton>
    </Link>
  )
}

export { SubmitButton, SubmitButtonMobile }
